<script>
  export let text = 'welcome';
  export let eventName = undefined;

  import { navigate } from 'svelte-routing';
  import api from '../services/api';

  import QRCode from './QRJS.svelte';
  import ModalPanel from './ModalPanel.svelte';

  let qrActive = false;
  let logoutActive = false;
  let support = 0;
  function handleLogout () {
    api.signOut();
    navigate('/');
  }

  function handleReport () {
    support = 3;
    api.request({ path: `/events/send-to-support`, method: 'post', data: { eventName }, credentials: true })
      .then(data => {
        support = 4;
      })
      .catch(err => {
        console.error(err);
      })
  }
</script>

<style>
  .clickable {cursor: pointer; padding: 20px;}
  .header {
    position: fixed;
    top:0;
    left:0;
    right:0;
  }
  .underheader {
    height: 90px;
  }
  .banner {
    height:50px;
  }
</style>

<ModalPanel active={qrActive} onClose={() => qrActive = false}>
  <span slot="header">QR</span>
  <span slot="content">
    <QRCode codeValue={window.location.href} squareSize=250/>
  </span>
  <div slot="footer">Scan this code to open the webapp on other devices.</div>
</ModalPanel>

<ModalPanel active={logoutActive} onClose={() => logoutActive = false}>
  <span slot="header">LOGOUT</span>
  <span slot="content">Do you want to logout?</span>
  <div slot="footer">
    <button class="button" on:click={() => { logoutActive = false }}>Cancel</button>
    <button class="button is-primary" on:click={handleLogout}>YES</button>
  </div>
</ModalPanel>

<ModalPanel active={support > 0} onClose={() => support = 0}>
  <span slot="header">SUPPORT</span>
  <span slot="content">
    {#if support == 1}
      <p>Looking for help?</p>
      <p>You can contact G&L support by phone. Please call</p>
      <a href="callto:08000 787326">08000 787326</a>
    {:else if support == 2}
      <p>Send event report?</p>
      <p/>
      <p class="has-text-left">This will</p>
      <p class="has-text-left">- send a detailed event report</p>
      <p class="has-text-left">- create a ticket with G&L support</p>
      <p class="has-text-left">- G&L support will contact you to resolve the issue.</p>
    {:else if support == 3}
      <p>Sending report...</p>
    {:else if support == 4}
      <p>Report sent.</p>
    {/if}
</span>
  <div slot="footer">
    {#if support == 1 && eventName}
      <p>Sent detailed event report and open ticket:</p>
      <button class="button is-primary" on:click={() => support=2}>Send event report</button>
      <p>Please use this in case of severe issues with the setup and try to call our support.</p>
    {:else if support == 2}
      <button class="button" on:click={() => support = 1}>Cancel</button>
      <button class="button is-primary" on:click={handleReport}>YES</button>
    {:else if support == 4}
      <button class="button is-primary" on:click={() => support=0}>OK</button>
    {/if}
  </div>
</ModalPanel>

<div class="header">
  <nav class="level is-mobile is-paddingless is-marginless has-background-primary has-text-white has-text-weight-bold is-size-3">
    <div class="level-item banner">G&L EventControl</div>
  </nav>
  <nav class="level is-mobile has-background-primary">
    <div class="level-left">
      <span class="icon has-text-white clickable"  on:click={() => navigate('/')}>
        <i class="fas fa-home" aria-hidden="true" />
      </span>
    </div>
    <div class="level-item has-text-white is-marginless">
      <span class="is-uppercase">
        {text}
      </span>
    </div>
    <div class="level-right">
      <span class="icon has-text-white clickable">
        <i class="fas fa-headset" aria-hidden="true" on:click={() => support=1} />
      </span>
      <span class="icon has-text-white clickable" on:click={() => qrActive=true}>
        <i class="fas fa-qrcode" aria-hidden="true" />
      </span>
      <span class="icon has-text-white clickable"  on:click={() => logoutActive=true}>
        <i class="fas fa-sign-out-alt" aria-hidden="true" />
      </span>
    </div>
  </nav>
</div>
<div class="underheader">
</div>
